import { cn } from '@/lib/utils';

/**
 * SpecialtyPill — Atom
 * Filter chip for specialty selection in the scheduling toolbar.
 * Keyboard navigable toggle button.
 */

interface SpecialtyPillProps {
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
}

export function SpecialtyPill({ label, isSelected = false, onClick }: SpecialtyPillProps) {
  return (
    <button
      onClick={onClick}
      role="option"
      aria-selected={isSelected}
      className={cn(
        'px-3 py-1 rounded-full text-xs font-medium border transition-colors',
        isSelected
          ? 'bg-brand-primary text-text-inverse border-brand-primary'
          : 'border-border-default text-text-muted hover:border-brand-primary focus-visible:border-brand-primary'
      )}
    >
      {label}
    </button>
  );
}
